import API, { IRI, defaultGetHeaders } from '@/api';

const fetchGet = id => {
  const headers = Object.assign({}, defaultGetHeaders);
  headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;
  return fetch(`${API}${IRI.exam}${id}`, { headers });
};

export default fetchGet;
